import { render, staticRenderFns } from "./PageEventGameScore.vue?vue&type=template&id=3fc499b4&scoped=true&"
import script from "./PageEventGameScore.vue?vue&type=script&lang=js&"
export * from "./PageEventGameScore.vue?vue&type=script&lang=js&"
import style0 from "./PageEventGameScore.vue?vue&type=style&index=0&id=3fc499b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc499b4",
  null
  
)

export default component.exports